'use strict';

/**
 * Collection of all datepicker component related scripts
 */
var datepicker = {};

// Model Includes
var DatepickerModel = require('../model/datepicker');

// Constant Includes
var CONSTANTS = {
    DATEPICKER: require('../constants/datepicker')
};

// Constants
var ATTRIBUTES = CONSTANTS.DATEPICKER.ATTRIBUTES;

/**
 * Initialize all datepicker components.
 * @param {null | undefined | JQuery<HTMLElement>} _$datepickers - initialize datepickers.
 */
datepicker.init = function (_$datepickers) {
    // Constants
    var $datepickers = $(`[${ATTRIBUTES.DATA.IS_DATE_PICKER}]:not([${ATTRIBUTES.DATA.IS_LOADED}=true])`);

    // Get datepickers to initialize
    if (_$datepickers !== null && _$datepickers !== undefined && _$datepickers.length) {
        $datepickers = _$datepickers;
    }

    // Initialize window global variable that stores all custom date pickers active in page
    if (!('comCustomDatepickers' in window) || !Array.isArray(window.comCustomDatepickers)) {
        window.comCustomDatepickers = [];
    }

    $datepickers.each(function (index, element) {
        window.comCustomDatepickers.push(new DatepickerModel($(element)));
    });
};

/**
 * Collection of Jquery static functions.
 */
datepicker.jqueryStatic = function () {
    /**
     * Initialize a collection of datepickers.
     * @param {JQuery<HTMLElement>} $datepickers - to initialize
     */
    $.comDatepicker = function ($datepickers) {
        datepicker.init($datepickers);
    };
};

module.exports = datepicker;
